import React from "react";
import renderErrors from "../validations/renderErrors";

const ProfileForm = ({
  closeModal,
  errors,
  handleDeleteAccount,
  handleSubmit,
  image,
  label,
  onChangeImage,
  setErrors,
  setPreviewMessage,
}) => (
  <div className="upload-modal">
    <div className="desktop-header">
      <button className="close-btn" onClick={closeModal}>
        X
      </button>
      <h2>Update your profile photo</h2>
    </div>
    <form
      onChange={() => {
        setErrors({});
      }}
      onSubmit={handleSubmit}
    >
      <div className="api-error">{errors && renderErrors(errors)}</div>
      <div className="input-container">
        <label className="file-input">
          {label}
          <input
            type="file"
            name="image"
            value={image}
            onChange={onChangeImage}
            required
            accept="image/jpg, image/jpeg, image/png"
          />
        </label>
      </div>
      <div>
        {image && (
          <button
            onClick={() => {
              setPreviewMessage(false);
            }}
            className="auth-btn"
          >
            Upload
          </button>
        )}
      </div>
    </form>
    <p className="delete-link" onClick={handleDeleteAccount}>
      <span className="auth-link">Delete</span> your account
    </p>
  </div>
);

export default ProfileForm;
